module.exports = __webpack_public_path__ + "static/la-ventures--alex-trend-93f5f5799c52e1cb6b93556b07834d2a.mp4";